var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "D",
    transform: "translate(13401 17249)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4018",
    "data-name": "Rectangle 4018",
    width: 60,
    height: 60,
    transform: "translate(-13401 -17249)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M10.58,47.21a1.221,1.221,0,1,1,1.176,2.14L6.339,52.332a1.222,1.222,0,0,1-1.659-.483l-.01-.017a26.123,26.123,0,1,1,44.864.059,1.22,1.22,0,0,1-1.634.443v0l-5.418-2.982a1.221,1.221,0,1,1,1.176-2.14l4.362,2.4A23.329,23.329,0,0,0,49.942,44.8,23.743,23.743,0,0,0,44.7,22.644L42.8,24.539a1.225,1.225,0,0,1-1.732-1.732l1.895-1.895A23.587,23.587,0,0,0,28.34,14.853v2.588a1.224,1.224,0,0,1-2.449,0V14.853a23.571,23.571,0,0,0-14.625,6.059l1.895,1.895a1.225,1.225,0,1,1-1.732,1.732L9.534,22.644A23.641,23.641,0,0,0,6.211,49.615l4.362-2.4ZM25.173,42.2a4.2,4.2,0,0,0-1.5,1.341A1.222,1.222,0,0,1,21.5,42.49l4.449-14.454a1.221,1.221,0,0,1,2.336-.008l4.435,14.408a1.223,1.223,0,0,1-2.161,1.1A4.175,4.175,0,0,0,25.167,42.2Zm-4.541,4.939a1.222,1.222,0,0,1,2.4-.46,4.162,4.162,0,0,0,8.17,0,1.222,1.222,0,0,1,2.4.46,6.608,6.608,0,0,1-12.971,0Z",
    transform: "translate(-13398 -17252.371)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.1e396798935ef7e9da94d966c89e4fa9.svg";
export { ForwardRef as ReactComponent };